<template>
    <div class="smart-spacing">
        <p class="h2">Thanks for signing up!</p>
        <p>
            We received your signup request and will review it shortly.
            You can expect to hear from us within one business day.
        </p>
        <p>If you have any questions in the meantime, feel free to reach out.</p>
    </div>
</template>
